<template>
  <div class="search-page">
    <!-- 右上角按钮组 -->
    <div class="top-buttons">
      <!-- 线路检测按钮 -->
      <button class="network-test-btn" @click="testNetwork()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M12 2L2 7v10c0 5.55 3.84 10 9 11 1.16-.21 2.31-.48 3.38-.84"
          ></path>
          <path d="M22 12c0 1.25-.23 2.45-.64 3.56"></path>
          <path
            d="M18 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4z"
          ></path>
          <circle cx="12" cy="8" r="2"></circle>
        </svg>
        线路检测
      </button>

      <!-- 主题切换器 -->
      <div class="theme-switcher">
        <div class="theme-dropdown">
          <button class="theme-button" @click="toggleDropdown()">
            切换主题
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M6 9l6 6 6-6"></path>
            </svg>
          </button>
          <div class="dropdown-content" id="themeDropdown">
            <div class="dropdown-item active" @click="changeTheme('green')">
              绿色
            </div>
            <div class="dropdown-item" @click="changeTheme('blue')">蓝色</div>
            <div class="dropdown-item" @click="changeTheme('red')">玫红</div>
            <div class="dropdown-item" @click="changeTheme('orange')">黄色</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 动态背景形状 -->
    <div class="background-shapes">
      <div class="shape"></div>
      <div class="shape"></div>
      <div class="shape"></div>
      <div class="shape"></div>
      <div class="shape"></div>
      <div class="shape"></div>
    </div>

    <div class="main-container">
      <div class="search-section">
        <h1 class="search-title">发现更多精彩</h1>
        <div class="search-box">
          <input
            v-model="searchValue"
            type="text"
            class="search-input"
            placeholder="搜索你感兴趣的内容..."
          />
          <button class="search-btn" @click="search">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchValue: "",
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "viewport",
          content:
            "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,userscalable=no",
        },
      ],
    };
  },
  mounted() {
    this.setTitle();
  },
  methods: {
    toggleDropdown() {
      const dropdown = document.getElementById("themeDropdown");
      dropdown.classList.toggle("show");
    },
    async changeTheme(theme) {
      document.documentElement.setAttribute("data-theme", theme);
      // 更新背景形状颜色
      this.updateShapeColors(theme);

      // 更新下拉菜单活跃状态
      const items = document.querySelectorAll(".dropdown-item");
      items.forEach((item) => item.classList.remove("active"));

      const themeNames = {
        green: "绿色",
        blue: "蓝色",
        red: "玫红",
        orange: "黄色",
      };
      const activeItem = Array.from(items).find(
        (item) => item.textContent === themeNames[theme]
      );
      if (activeItem) {
        activeItem.classList.add("active");
      }

      // 关闭下拉菜单
      document.getElementById("themeDropdown").classList.remove("show");
    },
    updateShapeColors(theme) {
      const shapes = document.querySelectorAll(".shape");
      const colors = {
        green: {
          light: "rgba(5, 150, 105, 0.1)",
          lighter: "rgba(5, 150, 105, 0.05)",
          medium: "rgba(5, 150, 105, 0.08)",
          minimal: "rgba(5, 150, 105, 0.03)",
          soft: "rgba(5, 150, 105, 0.06)",
          faint: "rgba(5, 150, 105, 0.02)",
        },
        blue: {
          light: "rgba(37, 99, 235, 0.1)",
          lighter: "rgba(37, 99, 235, 0.05)",
          medium: "rgba(37, 99, 235, 0.08)",
          minimal: "rgba(37, 99, 235, 0.03)",
          soft: "rgba(37, 99, 235, 0.06)",
          faint: "rgba(37, 99, 235, 0.02)",
        },
        red: {
          light: "rgba(225, 29, 72, 0.1)",
          lighter: "rgba(225, 29, 72, 0.05)",
          medium: "rgba(225, 29, 72, 0.08)",
          minimal: "rgba(225, 29, 72, 0.03)",
          soft: "rgba(225, 29, 72, 0.06)",
          faint: "rgba(225, 29, 72, 0.02)",
        },
        orange: {
          light: "rgba(80, 63, 50, 0.1)",
          lighter: "rgba(80, 63, 50, 0.05)",
          medium: "rgba(80, 63, 50, 0.08)",
          minimal: "rgba(80, 63, 50, 0.03)",
          soft: "rgba(80, 63, 50, 0.06)",
          faint: "rgba(80, 63, 50, 0.02)",
        },
      };

      const themeColors = colors[theme];

      shapes.forEach((shape, index) => {
        switch (index) {
          case 0:
          case 1:
          case 2:
          case 4:
            shape.style.background = `linear-gradient(45deg, ${themeColors.light}, ${themeColors.lighter})`;
            break;
          case 3:
            shape.style.background = `linear-gradient(135deg, ${themeColors.medium}, ${themeColors.minimal})`;
            break;
          case 5:
            shape.style.background = `linear-gradient(225deg, ${themeColors.soft}, ${themeColors.faint})`;
            break;
        }
      });
    },
    async search() {
      let data = {
        s: this.searchValue,
      };
      let result = await this.$http.postAxiosMethod("/search", data, {
        hideErorr: true,
      });
      if (result.code == 0) {
        sessionStorage.setItem("token", result.token);
        this.$router.push("/login");
      } else {
        location.href =
          "https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=" +
          this.searchValue;
      }
    },
    setTitle() {
      let title = sessionStorage.getItem("title");
      this.$setDocumentTitle(title);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  /* 右上角按钮容器 */
  .top-buttons {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    gap: 10px;
  }

  /* 线路检测按钮 */
  .network-test-btn {
    background: var(--new-bg-primary);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }

  .network-test-btn:hover {
    background: var(--new-bg-primary);
    transform: translateY(-2px);
  }

  .network-test-btn:active {
    transform: translateY(0);
  }

  /* 主题切换按钮 */
  .theme-switcher {
    position: relative;
  }

  .theme-dropdown {
    position: relative;
    display: inline-block;
  }

  .theme-button {
    background: var(--new-bg-primary);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .theme-button:hover {
    background: var(--new-bg-primary);
    transform: translateY(-2px);
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    background: white;
    min-width: 120px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 1001;
    overflow: hidden;
    margin-top: 5px;
  }

  .dropdown-content.show {
    display: block;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .dropdown-item {
    color: #333;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 14px;
  }

  .dropdown-item:hover {
    background: #f5f5f5;
  }

  .dropdown-item.active {
    background: var(--new-bg-primary);
    color: white;
  }

  /* 动态背景形状 */
  .background-shapes {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
  }

  .shape {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(
      45deg,
      rgba(5, 150, 105, 0.1),
      rgba(5, 150, 105, 0.05)
    );
    animation: float 6s ease-in-out infinite;
  }

  .shape:nth-child(1) {
    width: 200px;
    height: 200px;
    top: 10%;
    left: 15%;
    animation-delay: 0s;
    animation-duration: 8s;
  }

  .shape:nth-child(2) {
    width: 150px;
    height: 150px;
    top: 60%;
    right: 20%;
    animation-delay: 2s;
    animation-duration: 10s;
  }

  .shape:nth-child(3) {
    width: 100px;
    height: 100px;
    bottom: 20%;
    left: 10%;
    animation-delay: 4s;
    animation-duration: 7s;
  }

  .shape:nth-child(4) {
    width: 300px;
    height: 300px;
    top: 20%;
    right: 10%;
    animation-delay: 1s;
    animation-duration: 12s;
  }

  .shape:nth-child(5) {
    width: 80px;
    height: 80px;
    top: 80%;
    right: 40%;
    animation-delay: 3s;
    animation-duration: 9s;
  }

  .shape:nth-child(6) {
    width: 250px;
    height: 250px;
    bottom: 30%;
    right: 5%;
    animation-delay: 5s;
    animation-duration: 11s;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px) rotate(0deg);
      opacity: 0.3;
    }
    25% {
      transform: translateY(-20px) rotate(90deg);
      opacity: 0.5;
    }
    50% {
      transform: translateY(10px) rotate(180deg);
      opacity: 0.2;
    }
    75% {
      transform: translateY(-15px) rotate(270deg);
      opacity: 0.4;
    }
  }

  /* 添加一个微妙的脉动效果 */
  .shape:nth-child(even) {
    animation-name: pulse-float;
  }

  @keyframes pulse-float {
    0%,
    100% {
      transform: translateY(0px) scale(1);
      opacity: 0.2;
    }
    33% {
      transform: translateY(-25px) scale(1.1);
      opacity: 0.4;
    }
    66% {
      transform: translateY(15px) scale(0.9);
      opacity: 0.1;
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    min-height: 100vh;
    position: relative;
    z-index: 1;
  }

  .search-section {
    text-align: center;
    width: 100%;
    max-width: 800px;
    transform: translateY(-80px);
  }

  .search-title {
    font-size: 42px;
    color: var(--primary-color);
    margin-bottom: 30px;
    font-weight: 300;
    transition: color 0.3s ease;
  }

  .search-box {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .search-input {
    width: 100%;
    height: 50px;
    padding: 0 50px 0 20px;
    border: 2px solid #ddd;
    border-radius: 25px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s, box-shadow 0.3s;
  }

  .search-input:focus {
    border-color: var(--new-primary-color);
    // box-shadow: 0 0 0 3px var(--new-primary-color);
  }

  .search-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 40px;
    height: 40px;
    background: var(--new-bg-primary);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .search-btn:hover {
    background: var(--new-bg-primary);
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    .search-title {
      font-size: 28px;
    }

    .top-buttons {
      flex-direction: column;
      gap: 8px;
    }

    .network-test-btn,
    .theme-button {
      padding: 8px 16px;
      font-size: 12px;
    }
  }
}
</style>
